import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { NavLink } from "react-router";

import { useCurrentEmployeeTenants } from "~api/tenants";
import logoIcon from "~assets/svg/grewe-logo-icon.svg";
import logo from "~assets/svg/logo.svg";
import { ROUTES } from "~components/routeDefinitions.ts";
import { useCurrentTenant } from "~contexts/CurrentTenantContext/CurrentTenantContext.tsx";
import { useOfflineContext } from "~contexts/OfflineContext/useOfflineContext";
import { useUserProfile } from "~contexts/UserProfileContext/UserProfileContext.tsx";
import styles from "./Header.module.scss";
import { ManagerSelect } from "./ManagerSelect/ManagerSelect";
import { SettingsButton } from "./SettingsButton/SettingsButton";
import { Sync } from "./Sync/Sync";
import { TenantMenu } from "./TenantMenu/TenantMenu.tsx";
import { UserMenu } from "./UserMenu/UserMenu.tsx";

export function Header() {
  const userProfile = useUserProfile();
  const theme = useTheme();
  const { data: tenants } = useCurrentEmployeeTenants();
  const { number: tenantNumber } = useCurrentTenant();
  const isUpMedium = useMediaQuery(theme.breakpoints.up("md"));
  const logoSrc = isUpMedium ? logo : logoIcon;
  const tenantArray = tenants || [];
  const { isOfflineReady } = useOfflineContext();

  return (
    // `data-offline-ready` is a non-visual marker used by e2e tests to detect
    // when the service worker has finished precaching (see e2e/helpers/offline.ts).
    <div
      className={styles.header}
      data-offline-ready={isOfflineReady || undefined}
    >
      <div className={styles.header__left}>
        <NavLink
          className={styles.logo}
          to={ROUTES.dashboard.link({ tenantNumber })}
        >
          <img src={logoSrc} alt="Grewe Logo" />
        </NavLink>
        <div className={styles.header__left__menus}>
          <TenantMenu tenants={tenantArray} />
          <ManagerSelect />
        </div>
      </div>
      <div className={styles.header__right}>
        <Sync />
        <SettingsButton />
        <UserMenu userName={userProfile?.name} />
      </div>
    </div>
  );
}
